import { render, staticRenderFns } from "./ListChecklistTemplate.vue?vue&type=template&id=459649a2"
import script from "./ListChecklistTemplate.vue?vue&type=script&lang=js"
export * from "./ListChecklistTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListChecklistTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459649a2')) {
      api.createRecord('459649a2', component.options)
    } else {
      api.reload('459649a2', component.options)
    }
    module.hot.accept("./ListChecklistTemplate.vue?vue&type=template&id=459649a2", function () {
      api.rerender('459649a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListChecklistTemplate.vue"
export default component.exports